var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrollWrapper"},[_c('div',{class:['layout', _vm.fullHeight && 'layout--fullHeight'],style:({
      maxWidth: (_vm.maxWidth + "px"),
      minWidth: (_vm.minWidth + "px")
    })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }